export const GET_INITIAL_INFO = "GET_INITIAL_INFO";
export const GET_INITIAL_INFO_SUCCESS = "GET_INITIAL_INFO_SUCCESS";
export const GET_INITIAL_INFO_ERROR = "GET_INITIAL_INFO_ERROR";

export const GET_CATEGORIE_PARENT = "GET_CATEGORIE_PARENT";
export const GET_CATEGORIE_PARENT_SUCCESS = "GET_CATEGORIE_PARENT_SUCCESS";
export const GET_CATEGORIE_PARENT_ERROR = "GET_CATEGORIE_PARENT_ERROR";